// Lightweight session-storage activity tracker for the Explore (/explore) page.
// Kept separate from SiteFeedback.tsx so that file can stay
// component-only (required for Vite React Fast Refresh).

const ACTIVITY_KEY = "rp-explore-activity";

export function bumpExploreActivity(kind: "open" | "save") {
  if (typeof window === "undefined") return;
  try {
    const raw = sessionStorage.getItem(ACTIVITY_KEY);
    const state: { opens: number; saves: number } = raw ? JSON.parse(raw) : { opens: 0, saves: 0 };
    if (kind === "open") state.opens += 1;
    if (kind === "save") state.saves += 1;
    sessionStorage.setItem(ACTIVITY_KEY, JSON.stringify(state));
    window.dispatchEvent(new CustomEvent("rp-activity"));
  } catch {
    /* noop */
  }
}

export function readExploreActivity(): { opens: number; saves: number } {
  if (typeof window === "undefined") return { opens: 0, saves: 0 };
  try {
    const raw = sessionStorage.getItem(ACTIVITY_KEY);
    return raw ? JSON.parse(raw) : { opens: 0, saves: 0 };
  } catch {
    return { opens: 0, saves: 0 };
  }
}